
/**
 * aにbの情報を上書きする。
 */
export const objectMerge = (object: object, source: object) => {
    Object.keys(object).forEach((key: keyof typeof object) => {
        if (key in source) {
            const aValue = object[key];
            const bValue = source[key];
            if (typeof bValue !== "object" && bValue !== undefined) {
                object[key] = bValue;
            } else if (typeof aValue === "object") {
                objectMerge(aValue, bValue);
            } else {
                object[key] = bValue;
            }
        }
    })
    return object;
}

